export class GetJobProgressStepsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "steps",
            "baseName": "steps",
            "type": "Array<JobProgressStep>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetJobProgressStepsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
